import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'typeface-open-sans/index.css';
import '../css/style.css';

import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'caroufredsel/jquery.carouFredSel-6.2.1-packed.js';
import 'scrollreveal/dist/scrollReveal.min.js';

jQuery(document).ready(function ($) {
    $('#carousel').carouFredSel({
        responsive: true,
        width: '100%',
        scroll: 2,
        items: {
            duration: 500,
            timeoutDuration: 0,
            start: 'random',
            pauseOnHover: 'immediate',
            //fx: 'scroll',
            easing: 'linear',
            width: 300,
            visible: {
                min: 3,
                max: 6
            }
        }
    });
});
window.sr = new window.scrollReveal({
    reset: true,
    mobile: false,
    move: '50px',
    vFactor: 0.40
});


let forms = document.querySelectorAll("form");

for (let form of Array.from(forms)) {

    form.addEventListener("submit", (e) => postForm(e, form));
}

function postForm(submitEvent, form) {
    submitEvent.preventDefault();
    let message = document.querySelector(".response-output");

    let submitButton = submitEvent.target.querySelector('input[type=submit]');

    submitButton.disabled = true;

    var formData = new FormData(form);
    formData.append("_url", window.location.href);

    fetch(submitEvent.target.action, {
        method: "post",
        body: formData
    }).then(response => {
        if (response.ok) {
            form.reset();
            submitButton.disabled = false;
            message.innerHTML =
                "<strong>Success!</strong> Your message was successfully sent.";
            jQuery('#submitResult').modal();
        } else {
            submitButton.disabled = false;
            message.innerHTML = "<strong>Error submitting, please contact us by phone.</strong>";
            jQuery('#submitResult').modal();
        }		
    });

}
